import { render, staticRenderFns } from "./PaymentTerm.vue?vue&type=template&id=48f782fc&scoped=true"
import script from "./PaymentTerm.vue?vue&type=script&lang=js"
export * from "./PaymentTerm.vue?vue&type=script&lang=js"
import style0 from "./PaymentTerm.vue?vue&type=style&index=0&id=48f782fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f782fc",
  null
  
)

export default component.exports